export enum USER_PREFERENCE_KEY {
	MEDIA_VIEWMODE = 'vbMediaViewMode',
	VIDEO_TRANSCRIBE_METADATA = 'vbVideoTranscribeMetadata'
}
